import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiCache } from 'cad/common/services/api/api-cache';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { AgreementInputData, DetailedVOMap } from 'cad/contracts/shared/components/dynamic-input-tables/types/dynamic-input-tables-types';




@Injectable()
export class AgreementContractPriceApi {

  private readonly endpoint: string = 'agreement/contract';

  constructor(
    private apiHelper: ApiHelper,
    private apiCache: ApiCache,
  ) {}

  public getInputs = (itemData: any): Observable<any> => {
    return this.apiHelper.request(`${ this.endpoint }/price/${ itemData.contractId }/inputs`);
  }

  public getProductData = (contractId: string | number): Observable<any> => {
    return this.apiHelper.request(`${ this.endpoint }/price/${ contractId }/price-with-scopes`);

  }

  public save = (data: any): Observable<any> => {
    let rows = Object.getOwnPropertyNames(data).map((el) => data[el]);
    let contractId = rows[0].agreementId;
    return this.apiHelper.request(`${ this.endpoint }/price/${ contractId }/inputs`, { body: rows });
  }

  public runPriceConfigurator = (contractId: number): Observable<any> => {
    return this.apiHelper.request(`${ this.endpoint }/price/${ contractId }/configurator`);
  }

  public getPriceDataWithScopesForDate(contractId: string, effDate: string): Observable<DetailedVOMap[]> {
    return this.apiHelper.request(`${ this.endpoint }/price/${ contractId }/price-with-scopes-for-date`, { body: JSON.stringify(effDate) });
  }

  public getPriceInputs(contractId: string, tableKey: string, effDate: string): Observable<AgreementInputData> {
    return this.apiHelper.request(`${this.endpoint}/price/${ contractId }/tableId/${ tableKey }/price-inputs-filter`, { body: { effDate } });
  }
}
